import React, { useEffect, useState } from 'react';
import TutorialStep from './TutorialStep';
import './styles/tutorial.css';

/**
 * Composant overlay principal du tutoriel
 * Affiche un fond semi-transparent et met en surbrillance les éléments ciblés
 */
const TutorialOverlay = ({ step, onNext, onPrevious, onSkip, currentStep, totalSteps }) => {
    const [highlightStyle, setHighlightStyle] = useState(null);

    useEffect(() => {
        if (!step.target || !step.highlight) {
            setHighlightStyle(null);
            return;
        }

        // Trouver l'élément à mettre en surbrillance
        const targetElement = document.querySelector(step.target);
        if (!targetElement) {
            setHighlightStyle(null);
            return;
        }

        // Calculer la position et la taille de l'élément
        const rect = targetElement.getBoundingClientRect();
        const padding = 8;

        setHighlightStyle({
            top: `${rect.top - padding}px`,
            left: `${rect.left - padding}px`,
            width: `${rect.width + padding * 2}px`,
            height: `${rect.height + padding * 2}px`
        });

        // Faire défiler jusqu'à l'élément si nécessaire
        targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center'
        });
    }, [step]);

    return (
        <div className="tutorial-overlay">
            {/* Fond semi-transparent */}
            <div className="tutorial-backdrop" />

            {/* Zone de surbrillance */}
            {highlightStyle && (
                <div
                    className="tutorial-highlight"
                    style={highlightStyle}
                />
            )}

            {/* Bulle d'aide */}
            <TutorialStep
                step={step}
                onNext={onNext}
                onPrevious={onPrevious}
                onSkip={onSkip}
                currentStep={currentStep}
                totalSteps={totalSteps}
            />
        </div>
    );
};

export default TutorialOverlay;
